import { COURSE_FETCH_ENDED, COURSE_FETCH_STARTED } from '../actions/types';
const defaultState = {
  data: null,
  status: 'initial'
};
const courseReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case COURSE_FETCH_STARTED:
      return {
        status: 'fetching'
      };
    case COURSE_FETCH_ENDED:
      return {
        data: action.data,
        status: 'fetched'
      };
    default:
      return state;
  }
};
export default courseReducer;